if(!customElements.get('review-slider')){
    class ReviewSlider extends HTMLElement{
        constructor(){
            super();
            this.config = this.querySelector('script[type="application/json"]').textContent;
            this.swiperEl = this.querySelector('.swiper');
            this.swiper = new Swiper(this.swiperEl, JSON.parse(this.config));
        }
    }
    customElements.define('review-slider', ReviewSlider);
}